import { http } from '../helpers/http'
import { buildFindAllUrl } from './shared.service'

const findAllActions = filters => {
  let url = '/actions'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

const findAllEvents = filters => {
  let url = '/events'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

const findAllInformations = filters => {
  let url = '/informations'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

export const mapService = {
  findAllActions,
  findAllEvents,
  findAllInformations
}
